import type { ParallaxSvgSpec } from '../../../../config/atmosphere/effectLayer.types';
import { placeWorldShape, type ShapePlacement } from './worldShapeKit';

/** Author at display scale: tall planes hold proportionate, separated landmarks
 * rather than stretching the existing low terrain strip. Built once at import. */
function depth(height: number, shapes: readonly ShapePlacement[], bank = ''): ParallaxSvgSpec {
  return { tile: { viewBoxWidth: 2400, viewBoxHeight: height,
    path: [bank, ...shapes.map(shape => placeWorldShape(...shape))].filter(Boolean).join(' ') } };
}

export const ELEMENTAL_DEPTH_HEIGHTS = {
  frostspire_peaks: 1280, scorched_dunes: 900, skyreach_isles: 1280,
} as const;

export const ELEMENTAL_DEPTH_BACKDROPS = {
  frostspire_peaks: depth(1280, [
    ['mountain', 120, 1280, 650, 1120], ['mountain', 1320, 1280, 680, 1040],
    ['crystal', 2150, 1280, 120, 490],
  ], 'M0 1280V1190L280 1174L620 1194L980 1182L1340 1198L1710 1176L2070 1194L2400 1190V1280Z'),
  scorched_dunes: depth(900, [
    ['mesa', 180, 900, 640, 680], ['mesa', 1320, 900, 520, 620],
    ['obelisk', 2110, 900, 90, 420],
  ], 'M0 900V810Q250 790 480 818T960 818T1440 818T1920 818Q2160 798 2400 810V900Z'),
  // No ground-filled bank: distinct floating bodies retain air above and below.
  skyreach_isles: depth(1280, [
    ['island', 120, 500, 500, 240], ['island', 1030, 430, 540, 240],
    ['island', 1780, 800, 450, 260], ['island', 700, 1150, 520, 240],
  ]),
} satisfies Record<keyof typeof ELEMENTAL_DEPTH_HEIGHTS, ParallaxSvgSpec>;
